import { getSpecialtyStorageFolder } from './specialtyCollections';

export const RESOURCE_CATEGORIES = [
  { value: 'anki-deck', label: 'Anki Deck' },
  { value: 'guide', label: 'Guide / PDF' },
  { value: 'other', label: 'Other' },
];

export const RESOURCE_VISIBILITIES = [
  { value: 'lead-magnet', label: 'Lead Magnet (public)' },
  { value: 'subscribers', label: 'Subscribers Only' },
  { value: 'private', label: 'Private (admin only)' },
];

export const MAX_RESOURCE_FILE_BYTES = 200 * 1024 * 1024; // 200 MB

export const ALLOWED_RESOURCE_EXTENSIONS = [
  'apkg', 'colpkg', 'pdf', 'zip', 'csv', 'txt', 'doc', 'docx', 'ppt', 'pptx',
];

export const getFileExtension = (fileName) => {
  if (!fileName || typeof fileName !== 'string') return '';
  const parts = fileName.split('.');
  if (parts.length < 2) return '';
  return parts[parts.length - 1].toLowerCase();
};

export const stripFileExtension = (fileName) => {
  if (!fileName || typeof fileName !== 'string') return '';
  const idx = fileName.lastIndexOf('.');
  return idx > 0 ? fileName.slice(0, idx) : fileName;
};

export const sanitizeFileName = (fileName) => {
  if (!fileName || typeof fileName !== 'string') return 'file';
  return fileName
    .trim()
    .replace(/[^a-zA-Z0-9._-]+/g, '_')
    .replace(/_{2,}/g, '_');
};

export const formatFileSize = (bytes) => {
  if (typeof bytes !== 'number' || isNaN(bytes) || bytes < 0) return '—';
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  if (i === 0) return `${bytes} B`;
  const value = Math.round((bytes / Math.pow(1024, i)) * 10) / 10;
  return `${value} ${units[i]}`;
};

export const validateResourceFile = (file) => {
  if (!file || !file.name) return { valid: false, error: 'No file provided.' };

  const ext = getFileExtension(file.name);
  if (!ext) return { valid: false, error: `"${file.name}" has no file extension.` };
  if (!ALLOWED_RESOURCE_EXTENSIONS.includes(ext)) {
    return { valid: false, error: `.${ext} files are not allowed.` };
  }
  if (file.size === 0) return { valid: false, error: `"${file.name}" is empty.` };
  if (file.size > MAX_RESOURCE_FILE_BYTES) {
    return {
      valid: false,
      error: `"${file.name}" is larger than ${formatFileSize(MAX_RESOURCE_FILE_BYTES)}.`,
    };
  }
  return { valid: true, error: null };
};

// Decks are kept separate per specialty, so the folder is prefixed the same
// way every other specialty-scoped asset in the app is.
export const buildResourceStoragePath = (specialtyId, fileId, fileName) => {
  const folder = getSpecialtyStorageFolder('resources', specialtyId);
  return `${folder}/${fileId}/${sanitizeFileName(fileName)}`;
};
